<template>
  <div>
    <v-card flat>
      <v-card-title primary-title class="text-center">
        <span v-if="estado">{{ menu_name }} activos</span>
        <span v-else>{{ menu_name }} eliminados</span>
      </v-card-title>
      <v-card-text>
        <h4 v-if="notita" class="text-center red--text mt-0 pt-0"> <b>NOTA:</b> Esta funcionalidad será reemplazada con la lista de programas aprobados en la oferta académica. </h4>
        <h5 class="my-1"><b>Sede:</b> {{ this.$store.state.CARGO.sede.nombre }}</h5>
        <div class="row">
          <div class="col-sm-6">
            <input
              v-model="nombre"
              type="text"
              class="form-control"
              placeholder="Buscar por nombre en la base de datos..." />
            <button class="btn btn-sm btn-link" @click="get_postgrados()">
              <span class="glyphicon glyphicon-search"></span> {{ txt_btn_listar }}
            </button>
          </div>
          <div class="col-sm-6 text-right">
            <router-link
              v-if="permiso_add"
              to="postgradoadd"
              v-show="!$store.state.isonlyread && $store.state.createPostgrado"
              class="btn btn-sm btn-link">
              <span class="glyphicon glyphicon-education"></span> Crear {{ menu_name }}
            </router-link>
            <button class="btn btn-sm btn-link" v-if="!estado" @click="setEstado(true)">
              <span class="glyphicon glyphicon-eye-open"></span> Ver Activos
            </button>
            <button class="btn btn-sm btn-link" v-if="estado" @click="setEstado(false)">
              <span class="glyphicon glyphicon-eye-close"></span> Ver Eliminados
            </button>
          </div>
        </div>

        <div class="text-center">
          <div style="display: inline-block" v-show="loading" class="loader"></div>
        </div>
        <div class="pull-right">
          <b class="rojito"></b> Por aprobar <b class="naranja"></b> Aprobado <b class="verde"></b> Se pueden crear
          programas
        </div>

        <small v-if="msg" class="text-primary">{{ msg }}</small>
        <!-- <v-skeleton-loader :loading="!items.length" transition="scale-transition" height="500" type="table"> -->
        <v-data-table :headers="headers" :items="items" :search="search" class="elevation-4 mt-4" :items-per-page="20">
          <!-- <template v-slot:top>
            <v-text-field outlined dense v-model="search" label="Buscar en los resultados" class="pa-4"></v-text-field>
          </template> -->

          <template v-slot:item.status="{ item }">
            <b :class="format_color(item)"></b>
          </template>
          <template v-slot:item.clasenetsuite="{ item }">
            <span> {{ item.clasenetsuite? item.clasenetsuite.nombre: '' }} </span>
          </template>

          <template v-slot:item.actions="{ item }">
            <v-tooltip bottom v-if="!$store.state.isonlyread && $store.state.updatePostgrado && estado">
              <template #activator="{ on, attrs }">
                <v-btn color="primary" v-bind="attrs" v-on="on" icon :disabled="item.status < 2">
                  <v-icon class="ma-2" color="primary" @click="showAddProgramarestv2(item)">mdi-plus</v-icon>
                </v-btn>
              </template>
              Crear nuevo Programa
            </v-tooltip>

            <v-tooltip bottom v-if="!$store.state.isonlyread && $store.state.updatePostgrado && estado">
              <template #activator="{ on, attrs }">
                <v-btn color="primary" v-bind="attrs" v-on="on" icon>
                  <v-icon class="ma-2" color="primary" @click="showModPostgrado(item)">mdi-pencil</v-icon>
                </v-btn>
              </template>
              Editar {{ menu_name }}
            </v-tooltip>

            <v-tooltip bottom v-if="$store.state.cambiarPostgradoStatus && estado">
              <template #activator="{ on, attrs }">
                <v-btn color="primary" v-bind="attrs" v-on="on" icon title="Aprobar Programa">
                  <v-icon class="ma-2" color="primary" @click="verProgramas(item)">mdi-eye</v-icon>
                </v-btn>
              </template>
              Ver Programas creados
            </v-tooltip>

            <v-tooltip bottom v-if="(!$store.state.isonlyread && estado) || isdirectorcca">
              <template #activator="{ on, attrs }">
                <v-btn
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  icon
                  data-toggle="modal"
                  data-target="#modalf"
                  :disabled="!permitido && !isdirectorcca">
                  <v-icon class="ma-2" color="primary" @click="cambiarPostgradoStatus(item)">mdi-cached</v-icon>
                </v-btn>
              </template>
              Aprobar {{ menu_name }}
            </v-tooltip>
          </template>
        </v-data-table>
        <!-- </v-skeleton-loader> -->
      </v-card-text>
      <modal id="modal" v-bind:obj="seleccionado" v-on:exito="modalExito" />
      <!-- <modalf id="modalf" v-bind:obj="seleccionadof" v-on:exito="modalExitof" :prog="seleccionadof.prog" /> -->
      <notifications group="auth" position="bottom right" />
      <post-programas ref="refPostProgramas" />
      <AaprobarPostgrado ref="refAaprobarPostgrado" />
    </v-card>
  </div>
</template>
<script>
  import gql from 'graphql-tag';
  import modal from '@/components/AEstado.vue';
  import { parseUnidadDuracion2, parseColorcito } from '@/components/Utils.js';
  // import modalf from '@/components/AAprobarStatus.vue';
  import PostProgramas from './PostProgramas';
  import AaprobarPostgrado from '../../components/AaprobarPostgrado.vue';
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        txt_btn_listar: 'Ver Mas',
        msg: '0 ' + process.env.VUE_APP_NAME_MENU,
        seleccionadof: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null, prog: {} },
        seleccionado: { xid: -1, xtitle: 'X', xbody: 'X', xsql: null },
        tamanio: 0,
        cursor: 10000000,
        estado: true,
        showbtnaprobar: true,
        nombre: '',
        search: '',
        postgrados: [],
        timeoutHnd: 0,
        permitido: false,
        loading: false,
        menu_name: process.env.VUE_APP_NAME_MENU,
        isdirectorcca: false,
        permiso_add: true,
        notita: false,
        //   ==================
        items: [],
        headers: [
          { text: '#', value: 'index', sortable: false },
          { text: 'Nombre', value: 'nombre' },
          { text: 'Categoria', value: 'categoria.nombre' },
          { text: 'Area', value: 'area.nombre' },
          { text: 'Netsuite', value: 'clasenetsuite' },
          { text: 'duracion', value: 'duracion_text' },
          { text: 'Carga Horaria', value: 'carga_horaria_text' },
          { text: 'creditaje', value: 'creditaje_text' },
          { text: 'Estado', value: 'status' },
          { text: 'Opciones', value: 'actions' },
          // { text: 'Objetivo', value: 'objetivo' },
          // { text: 'Dirigido', value: 'dirigido' },
        ],
      };
    },
    components: { modal, PostProgramas,AaprobarPostgrado },
    watch: {
      UNIDAD_NEGOCIO_ID() {
        this.get_postgrados();
        this.verificarPermiso();
      },
      nombre: function (a) {
        if (a != null && a.length > 3) this.txt_btn_listar = 'Buscar por nombre';
        else this.txt_btn_listar = 'Ver Mas';

        if (this.timeoutHnd) {
          clearTimeout(this.timeoutHnd);
          this.timeoutHnd = 0;
        }
        const vue = this;
        this.timeoutHnd = setTimeout(function () {
          if (vue.nombre.length > 3) {
            vue.cursor = 10000000;
            vue.get_postgrados();
          }
          vue.timeoutHnd = 0;
        }, 500);
      },
    },
    computed: {
      ...mapState({
        UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
        /*items: (state) => {
          if (state.UNIDAD_NEGOCIO_ID) {
            return state.postgrado.items.filter((item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID);
          }
          return [];
        },*/
      }),
    },
    methods: {
      showAddProgramarestv2(item) {
        this.$store.dispatch('postgrado/selectPostgrado', item);
        window.sessionStorage.setItem('xpostgradorest', JSON.stringify(item));
        this.$router.push({ name: 'programaviewrest' });
      },
      showModPostgrado(item) {
        // window.console.log('iiii',item);
        this.$store.dispatch('postgrado/selectPostgrado', item);
        window.sessionStorage.setItem('xpostgrado', JSON.stringify(item));
        this.$router.push({ name: 'postgradomod' });
      },
      verProgramas(item) {
        this.$store.dispatch('postgrado/selectPostgrado', item);
        this.$refs.refPostProgramas.showThisView(item); 
      },
      load_data() {
        this.get_postgrados();
      },
      format_color(item) {
        return parseColorcito(item.status);
      },
      dialogo(tit, txt) {
        this.$dialog
          .confirm('<b>' + tit + '</b><br><br>' + txt)
          .then(function () {})
          .catch(function (e) {
            window.console.error(e);
          });
      },
      async get_postgrados() {
        this.items = [];
        this.loading = true;
        const vue = this;
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        const qs = gql`query{ getPostgrados( cursor:${this.cursor}, estado:${this.estado}, unidad_negocio_id:${
          unidad
        }
      ${this.nombre ? ',nombre:"' + this.nombre.trim() + '"' : ''})
        {id,nombre,duracion,creditaje,unidad_negocio_id,status,carga_horaria,unidad_duracion,estado,objetivo,dirigido,categoria{id,nombre,clase_netsuite_id},area{id,nombre},clasenetsuite{id nombre}}}`;
        // window.console.log('getPostgrados', qs.loc.source.body);
        let hrs = unidad == 15? 'creditos':'horas'
        await this.$apollo
          .query({ query: qs })
          .then(({ data }) => {
            //   window.console.log('getPostgrados', JSON.stringify(data));
            let items = data.getPostgrados.map((item, i = 0) => {
              item.index = ++i;
              item.duracion_text = `${item.duracion} ${parseUnidadDuracion2(item.unidad_duracion)}`;
              item.carga_horaria_text = `${item.carga_horaria} horas`;
              item.creditaje_text = `${item.creditaje} ${hrs}`;
              return item;
            });
            // window.console.log('itemssss:',items);
            vue.loading = false;
            this.$store.dispatch('postgrado/setPostgrados', items);
            vue.search = vue.nombre;
            if (!this.items.length) {
              this.items = items;
              const uno = items[0].unidad_negocio_id
              if(uno == 10){
                this.notita = true
              }else{
                this.notita = false
              }
            }
          })
          .catch(() => {
            !this.items.length
              ? this.$root.$notify.show(`No se pudo obtener ${this.menu_name}`, { color: 'primary' })
              : null;
            vue.loading = false;
          });
      },
      setEstado(est) {
        this.estado = est;
        this.modalExito();
      },
      showEliminar(item) {
        const msg = 'Cambiar Estado';
        const body = `El ${this.menu_name} ${item.categoria.nombre} :  ${item.nombre} sera cambiado.`;
        const tag = gql`mutation{ cambiarEstadoPostgrado(input:{id:${
          item.id
        },estado:${!item.estado}}){ok,errors{message}} }`;
        this.seleccionado = { xid: item.id, xtitle: msg, xbody: body, xsql: tag };
      },
      modalExitof(id_postgrado, newFase) {
        // no recargar la lista de postgrados
        var pos = this.items.find((x) => x.id == id_postgrado);
        pos.status = newFase;
      },
      cambiarPostgradoStatus(post){
        // this.seleccionadof.prog = post;
        this.$refs.refAaprobarPostgrado.openmodal(post);
      },
      /*
      cambiarPostgradoStatusBK(post) { 
        // 21373 35886
        let negocioid = this.$store.state.CARGO.sede.unidad_negocio;
        let sedeid = this.$store.state.CARGO.sede.id
        window.console.log('//////////////', negocioid);

        // window.console.log('negocioid', negocioid);
        if (negocioid == 1) {
          let userid = this.$store.state.DATA_USER.id;
          let perm = userid == 95 || userid == 35886 || userid == 59716;
          const apidev = process.env.VUE_APP_GRAPHQL;
          let isdevmode = false; 
          if( apidev.includes("apidev") ){ isdevmode = true; } 

          if (perm || isdevmode) {
            this.seleccionadof.prog = post;
            if(isdevmode) this.$root.$notify.show(`Autorizado en modo pruebas`, { color: 'green', x: 'right' });
          } else {
            setTimeout(() => {
              window.$('#modalf').modal('toggle');
            }, 130);
            this.$root.$notify.show(`No tiene autorizacion para esta accion`, { color: 'red', x: 'right' });
          }
        } else if (negocioid == 10) {
          let userid = this.$store.state.DATA_USER.id;
          let perm = userid == -43 || userid == 8017 || userid == 73 || userid == 864 || userid == 35886 || userid == 59716;
          if (perm) {
            this.seleccionadof.prog = post;
          } else {
            setTimeout(() => {
              window.$('#modalf').modal('toggle');
            }, 130);
            this.$root.$notify.show(`No tiene autorizacion para esta accion`, { color: 'red', x: 'right' });
          }
        } else if (negocioid == 12) {
          let userid = this.$store.state.DATA_USER.id;
          let carg = this.$store.state.CARGO.id;
          window.console.log('carg',carg);
          let perm = userid == 46812 || userid == 25174;
          if (perm || carg == 6) {
            this.seleccionadof.prog = post;
          } else {
            setTimeout(() => {
              window.$('#modalf').modal('toggle');
            }, 130);
            this.$root.$notify.show(`No tiene autorizacion para esta accion`, { color: 'red', x: 'right' });
          }
        } else if (negocioid == 14) { // ispi
          let userid = this.$store.state.DATA_USER.id;
          let carg = this.$store.state.CARGO.id;
          let ispaula_upi = sedeid == 121 && userid == 12988
          let perm = userid == 12988 || userid == 104802;
          if (perm || carg == -6 || ispaula_upi) {
            this.seleccionadof.prog = post;
          } else {
            setTimeout(() => {
              window.$('#modalf').modal('toggle');
            }, 130);
            this.$root.$notify.show(`No tiene autorizacion para esta accion`, { color: 'red', x: 'right' });
          }
        } else if (negocioid == 15) { // upi
          
          // ID: 65958	5153434	Claudia	Escobar	Salguero
          // ID: 76447	10384039	Clarice	Romero	Ordoñez
          
          let userid = this.$store.state.DATA_USER.id;
          let ispaula_upi = sedeid == 121 && userid == 12988
          let perm = userid == 65958 || userid == 76447 || userid == 43; 
          const apidev = process.env.VUE_APP_GRAPHQL;
          let isdevmode = false;
          if( apidev.includes("apidevrrrrrr") ){ isdevmode = true; } 

          if (perm || isdevmode || ispaula_upi) {
            this.seleccionadof.prog = post;
            if(isdevmode) this.$root.$notify.show(`Autorizado en modo pruebas`, { color: 'green', x: 'right' });
          } else {
            setTimeout(() => {
              window.$('#modalf').modal('toggle');
            }, 230);
            this.$root.$notify.show(`No tiene autorizacion para esta accion`, { color: 'red', x: 'right' });
          }
        } else if (negocioid == 2){ // cca 
          let userid = this.$store.state.DATA_USER.id;
          let perm = userid == 95 || userid == 35886 || userid == 113600 || userid == 59716;
          if (perm) {
            this.seleccionadof.prog = post;
          } else {
            setTimeout(() => {
              window.$('#modalf').modal('toggle');
            }, 130);
            this.$root.$notify.show(`No tiene autorizacion para aprobar`, { color: 'red', x: 'right' });
          }

        }
        else {
          this.seleccionadof.prog = post;
        }
      },
      */
      modalExito() {
        this.cursor = 1000000;
        this.postgrados = [];
        this.nombre = '';
        this.getPostgrados();
      },
      verificarPermiso() {
        this.permiso_add = true;
        /* let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        let esam = 1;
        if (unidad == esam) {
          let usuarioid = this.$store.state.DATA_USER.id;
          let ok = usuarioid == -1 || usuarioid == 21373 || usuarioid == 35886 || usuarioid == 95;
          if (ok) this.permiso_add = true;
          else this.permiso_add = false;
          window.console.log(unidad, usuarioid);
        } */
      },
    },
    mounted() {
      this.verificarPermiso();
      // al editar programa se guarda en memo, aqui lo quitamos para agregar nuevo programa
      sessionStorage.removeItem('xprogramarest');
      window.localStorage.removeItem('rest_idprograma');
      let cargo = this.$store.state.CARGO.id;
      let userid = this.$store.state.DATA_USER.id;
      let userrobertocca = 32173;
      let usermauren = 3506;
      this.permitido = cargo == 1 || cargo == 17 || userid == 9030 || userid == usermauren || userid == userrobertocca;
      this.isdirectorcca = cargo == 5 || userrobertocca;
      //window.console.log(this.isdirectorcca);
      this.load_data();
    },
  };
</script>
<style lang="css" scope>
  .rojito {
    border-radius: 50%;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: red;
  }
  .naranja {
    border-radius: 50%;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: orange;
  }
  .verde {
    border-radius: 50%;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: green;
  }
  .marron {
    border-radius: 50%;
    display: inline-block;
    width: 10px;
    height: 10px;
    background: brown;
  }
</style>
